export enum OpzioniTipoFattura {
  PARCELLA_PRIVATI = 'Parcella Privati',
  PARCELLA_SDI = 'Parcella SDI',
  NOTA_CREDITO_SDI = 'Nota di Credito SDI',
  NOTA_CREDITO_STS = 'Nota di Credito STS',
}

export enum PaymentType {
  EMPTY = '',
  BONIFICO = 'Bonifico',
  CONTANTI = 'Contanti',
  CARTA_DI_PAGAMENTO = 'Carta di Pagamento',
}
export enum UnitàDiMisura {
  PZ = 'PZ',
  PZ_LOWERCASE = 'pz',
  NR = 'NR',
  N = 'N',
  N_DOT = 'N.',
  N_DOT_LOWERCASE = 'n.',
  EA = 'EA',
  CAD = 'CAD',
  LT = 'LT',
  ST = 'ST',
  PCE = 'PCE',
  RT = 'RT',
  KG = 'KG',
  UM = 'UM',
  UL = 'UL',
  GIORNI = 'giorni',
  MC = 'mc',
  UTA = 'UTA',
}

export enum TipologiaCassaCode {
  TC09 = 'TC09',
  TC21 = 'TC21',
}

export const TipologiaCassaDescription = {
  [TipologiaCassaCode.TC09]:
    'TC09 Ente nazionale previdenza e assistenza medici (ENPAM)',
  [TipologiaCassaCode.TC21]:
    'TC21 Ente nazionale previdenza e assistenza psicologi (ENPAP)',
};

// This type helps with frontend display
export type TipologiaCassa = keyof typeof TipologiaCassaDescription;

// FIXME: empty string should not be accepted in the fields of the Invoices interface
export interface Invoices {
  id?: string;
  partita_iva: string; //auto-populated
  tipo: OpzioniTipoFattura | '';
  cliente: string;
  riferimento: string;
  numero: string;
  data: string; // date in format dd/mm/yyyy
  pagata: boolean;
  scadenza: string; // date in format dd/mm/yyyy
  tipo_pagamento: PaymentType | '';
  cassa_previdenza: boolean;
  tipologia_cassa: TipologiaCassa | '';
  percentuale_cassa: string;
  escludi_bollo?: boolean;
  linee_documento: NewInvoiceDocumentLine[];
  imponibile: string;
  cassa_previdenza_totale: string;
  imposta: string;
  bollo: string;
  banca_utente: string;
  iban_utente: string;
  banca_cliente: string;
  iban_cliente: string;
  stato: string; //can assume a set of values to decide (let's use the ones of acube)
  anno: string;
  totale: string; // is it needed or is the same as imponibile?
}

export interface TableInvoiceFields {
  id: string;
  progressivo_numero: string;
  progressivo_anno: number;
  stato: StatoFatturaSDI | StatoFatturaSTS;
  tipo: string;
  data: string;
  client_id: string;
  client_name: string;
  data_pagamento?: string;
  totale: string;
  pagata: boolean;
  sendable: boolean;
  modifiable: boolean;
  deletable: boolean;
  selectable: boolean;
}

export interface TableReceivedInvoiceFields {
  id: string;
  progressivo_numero: string;
  progressivo_anno: number;
  stato: string;
  tipo: string;
  data: string;
  mittente: string;
  totale: string;
  pagata: boolean;
}

export interface NewInvoice {
  tipo: OpzioniTipoFattura | '';
  client_id: string;
  cliente: string;
  riferimento: string;
  progressivo_numero: string;
  progressivo_anno: number;
  data: string; // date in format dd/mm/yyyy
  pagata: boolean;
  data_pagamento?: string;
  scadenza: string; // vista fattura for example
  pagamento: PaymentType | '';
  cassa_previdenza: boolean;
  tipologia_cassa: TipologiaCassa | '';
  percentuale_cassa: number;
  cassa_previdenza_iva?: number | null;
  cassa_previdenza_natura_iva?: string | null;
  escludi_bollo?: boolean;
  applica_bollo?: boolean;
  linee_documento: NewInvoiceDocumentLine[];
  imponibile: number;
  totale_cassa_previdenza: number;
  imposta: number;
  bollo: number;
  totale: number;
  doctor_bank_name: string;
  doctor_bank_iban: string;
  flag_opposizione?: boolean;
  totale_ritenuta?: number;
  notifications?: InvoiceNotification[];
}
export interface InvoiceNotification {
  type: string;
  created_at: string;
}

export interface NewSTSCreditNote {
  tipo: OpzioniTipoFattura | '';
  progressivo_numero: string;
  importo: string;
  numero_fattura_originale: string;
  id_originale?: string;
}

export interface NewInvoiceDocumentLine {
  descrizione: string;
  quantita: number; // aCube uses string for quantity and price.
  prezzo: number;
  sconto: number;
  iva: number;
  natura_iva: string;
  totale: number;
}

export interface InvoiceNextDraftNumber {
  progressivo_anno: number;
  progressivo_numero: string;
}

export interface InvoiceCompanyClient {
  id?: string;
  is_patient: boolean;
  patient_id?: string;
  patient_first_name?: string;
  patient_last_name?: string;
  company_name: string;
  tax_code: string;
  vat_number: string;
  unique_code: string;
  email: string;
  country: string;
  city: string;
  province: string;
  street_address: string;
  street_number: string;
  zip_code: string;
}

export interface InvoicePrivateClient {
  id?: string;
  is_patient: boolean;
  patient_id?: string;
  patient_first_name?: string;
  patient_last_name?: string;
  client_first_name: string;
  client_last_name: string;
  client_email: string;
  client_number: string;
  client_tax_code: string;
  client_country: string;
  client_city: string;
  client_province: string;
  client_street_address: string;
  client_street_number: string;
  client_zip_code: string;
}

export interface InvoicePatient {
  id: string;
  first_name: string;
  last_name: string;
  tax_code: string;
  email: string | null;
  number: string;
}

export enum StatoFatturaSDI {
  BOZZA = 'Bozza',
  PRONTA = 'Pronta',
  ERRORE_ELABORAZIONE = 'Errore Elaborazione',
  PRESA_IN_CARICO = 'Presa in Carico',
  QUARANTENA = 'Quarantena',
  INVIATA = 'Inviata',
  SCARTATA = 'Scartata',
  EMESSA_E_NON_CONSEGNATA = 'Emessa e Non Consegnata',
  EMESSA_E_CONSEGNATA = 'Emessa e Consegnata',
}

export enum StatoFatturaSTS {
  BOZZA = 'Bozza',
  PRONTA = 'Pronta',
  ACCOLTA_SENZA_SEGNALAZIONI = 'Accolta senza segnalazioni',
  RISCONTRATO_ERRORE_BLOCCANTE = 'Riscontrato errore bloccante',
  ACCOLTA_CON_SEGNALAZIONI = 'Accolta con segnalazioni',
}

export const spiegazioneStatoFatturaSDI = {
  [StatoFatturaSDI.BOZZA]:
    'La fattura è stata creata ma non è stata ancora inviata.',
  [StatoFatturaSDI.ERRORE_ELABORAZIONE]:
    "Si è verificato un errore durante l'elaborazione della fattura (Problema tecnico di invio al Sistema di Interscambio).",
  [StatoFatturaSDI.PRESA_IN_CARICO]:
    'La fattura è in attesa di essere elaborata e non risulta ancora trasmessa al Sistema di Interscambio.',
  [StatoFatturaSDI.QUARANTENA]:
    'La fattura non è ancora stata inviata al Sistema di Interscambio. Un nuovo tentativo verrà effettuato a breve.', // TODO: check if we need to display this
  [StatoFatturaSDI.INVIATA]:
    "Inviata al Sistema di Interscambio. Attendi la notifica di SDI con l'esito dell'invio (entro 5 giorni).",
  [StatoFatturaSDI.SCARTATA]:
    'La fattura è stata rifiutata dal Sistema di Interscambio che ha restituito un codice di errore.',
  [StatoFatturaSDI.EMESSA_E_NON_CONSEGNATA]:
    'La fattura è emessa e presente sul portale fatture e corrispettivi del cliente, tuttavia non è stata consegnata attraverso il metodo scelto (PEC o Codice Destinatario). Si ricorda che è necessario inviare una copia PDF della fattura al cliente.',
  [StatoFatturaSDI.EMESSA_E_CONSEGNATA]:
    'La fattura è stata emessa e consegnata da parte del Sistema di Interscambio.',
};

export const spiegazioneStatoFatturaSTS = {
  [StatoFatturaSTS.BOZZA]:
    'La fattura è stata creata ma non è stata ancora inviata.',
  [StatoFatturaSTS.ACCOLTA_SENZA_SEGNALAZIONI]:
    'La fattura è stata accolta senza segnalazioni.',
  [StatoFatturaSTS.RISCONTRATO_ERRORE_BLOCCANTE]:
    'Si è riscontrato un errore bloccante. La fattura è stata scartata.',
  [StatoFatturaSTS.ACCOLTA_CON_SEGNALAZIONI]:
    'La fattura è stata accolta con segnalazioni.',
};
